import { render, staticRenderFns } from "./OrdersListV2.vue?vue&type=template&id=6598ee0d&scoped=true&"
import script from "./OrdersListV2.vue?vue&type=script&lang=js&"
export * from "./OrdersListV2.vue?vue&type=script&lang=js&"
import style0 from "./OrdersListV2.vue?vue&type=style&index=0&id=6598ee0d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6598ee0d",
  null
  
)

export default component.exports